import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getTenants = () =>
  fetch(
    `${API_BASE_URL}/tenants`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN
    }
  )
  .then(res => res.json())


export const saveTenant = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/tenants`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editTenant = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/tenants/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteTenant = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/tenants/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN
    }
  )
  return await res.json()
}